import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';

import Container from './Container';
import { PricingCardsData } from '../constants/PricingCards';

const PricingCards = () => {
  const renderCacheWarn = () => {
    return (
      <div className="cache-warning">
        <ErrorOutlineIcon className="icon" />
        <h4>
          Locally saved files reside on your browser cache. If you clear your
          cache, the files will be inaccessible. Please save these files to a
          physical drive location to avoid this limitation or upgrade to the
          &nbsp;<span className="red-text">Premium plan</span>&nbsp; with cloud
          backup, and access your files on any device with no limitations.
        </h4>
      </div>
    );
  };

  const renderPriceCard = (data) => {
    const [isExpand, setIsExpand] = React.useState(false);
    return (
      <div className={`pricing-card ${data.red && `red-background`}`} style={{height: isExpand ? '100%' : 'auto' }}>
        <div className="top-wrapper">
          <h2 className="large-font">{data.heading}</h2>
          <h3 className="small-font">{data.description}</h3>
        </div>
        <div className={`body-wrapper ${isExpand && 'expand'}`}>
          <div className="feature-wrapper">
            <div className="pricing-wrapper">
              <span>$ {data.price}</span>
              {data.price !== 0 && (
                <span>
                  <span>/</span>
                  <span className="month">mo</span>
                </span>
              )}
            </div>
            {data.features.map((feature) => {
              return (
                <h4 className={`feature small-font ${feature.fade && `fade`}`}>
                  <CheckCircleOutlineOutlinedIcon className="feature-icon" />
                  <span>{feature.text}</span>
                </h4>
              );
            })}
          </div>
          {data.heading !== 'PREMIUM' && renderCacheWarn()}
        </div>
        <div className="button-wrapper">
            <Button onClick={()=>setIsExpand(!isExpand)} className="expand-button">{isExpand ? 'Less' :'More'}</Button>
            <Button
            href="https://screenapp.io/#/signin"
              className={`medium-font ${
                data.red ? `red-button` : `black-filled-button`
              }`}
              variant="contained"
            >
              Get Started
            </Button>
          </div>
      </div>
    );
  };

  return (
    <div className="pricing-cards-wrapper" id="pricing">
      <Container>
        <h2 className="global-heading large-font">Pricing</h2>
        <Grid container justify="center" spacing={6} className="grid-container">
          {PricingCardsData.map((data) => {
            return (
              <Grid item lg={3} md={4} xs={12}>
                {renderPriceCard(data)}
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

PricingCards.propTypes = {
  sectionData: PropTypes.any.isRequired,
};

export default PricingCards;
